"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _constants = require("../constants");
var _styledComponents = _interopRequireDefault(require("styled-components"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var ellipsisSvg = function ellipsisSvg(_ref) {
  var color = _ref.color,
    height = _ref.height,
    width = _ref.width,
    className = _ref.className;
  return /*#__PURE__*/React.createElement("svg", {
    width: width,
    height: height,
    className: className,
    viewBox: "0 0 24 6"
  }, /*#__PURE__*/React.createElement("g", {
    fill: color,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: "2.735",
    cy: "2.739",
    rx: "2.735",
    ry: "2.739"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.853 5.478c1.51 0 2.735-1.226 2.735-2.74C14.588 1.227 13.364 0 11.853 0c-1.51 0-2.735 1.226-2.735 2.74 0 1.512 1.224 2.738 2.735 2.738z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: "20.971",
    cy: "2.739",
    rx: "2.735",
    ry: "2.739"
  })));
};
var Ellipsis = (0, _styledComponents["default"])(ellipsisSvg).withConfig({
  displayName: "ellipsis__Ellipsis"
})(["cursor:pointer;&:hover{g{fill:", ";}}"], function (props) {
  return props.hoverColor;
});
Ellipsis.displayName = 'Ellipsis';
var defaultProps = {
  color: _constants.colors.mediumGrey,
  hoverColor: _constants.colors.darkestGrey,
  height: 6,
  width: 24
};
Ellipsis.defaultProps = defaultProps;
var _default = exports["default"] = Ellipsis;